export const getApplePaySession = () =>
  window.Cypress ? window.incTest.ApplePaySession : window.ApplePaySession;
